// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerDetailsTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  isNew: Types.Scalars['Boolean']['input'];
}>;


export type TradePartnerDetailsTabQuery = { __typename?: 'Query', tradePartner?: { __typename?: 'TradePartner', id: string, name: string, website?: string | null | undefined, internalNote?: string | null | undefined, intacctId?: string | null | undefined, doesMaterials: boolean, doesLabor: boolean, isSweetheart: boolean, sourceNote?: string | null | undefined, meetsRequirements: boolean, isLienWaiverReceiver: boolean, enableClickToPay: boolean, markets: Array<{ __typename?: 'Market', id: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string }>, source?: { __typename?: 'InternalUser', id: string } | null | undefined, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus }, paymentTerm: { __typename?: 'PaymentTerm', id: string, name: string } }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }>, paymentTerms: Array<{ __typename?: 'PaymentTerm', id: string, name: string }> };

export type TradePartnerDetails_PaymentTermFragment = { __typename?: 'PaymentTerm', id: string, name: string };

export type TradePartnerDetailsFragment = { __typename?: 'TradePartner', id: string, name: string, website?: string | null | undefined, internalNote?: string | null | undefined, intacctId?: string | null | undefined, doesMaterials: boolean, doesLabor: boolean, isSweetheart: boolean, sourceNote?: string | null | undefined, meetsRequirements: boolean, isLienWaiverReceiver: boolean, enableClickToPay: boolean, markets: Array<{ __typename?: 'Market', id: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string }>, source?: { __typename?: 'InternalUser', id: string } | null | undefined, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus }, paymentTerm: { __typename?: 'PaymentTerm', id: string, name: string } };

export const TradePartnerDetails_PaymentTermFragmentDoc = gql`
    fragment TradePartnerDetails_PaymentTerm on PaymentTerm {
  id
  name
}
    `;
export const TradePartnerDetailsFragmentDoc = gql`
    fragment TradePartnerDetails on TradePartner {
  id
  name
  website
  internalNote
  intacctId
  markets {
    id
  }
  tradeCategories {
    id
  }
  costCodes {
    id
  }
  doesMaterials
  doesLabor
  isSweetheart
  source {
    id
  }
  sourceNote
  meetsRequirements
  onboardingStatus {
    code
  }
  paymentTerm {
    ...TradePartnerDetails_PaymentTerm
  }
  isLienWaiverReceiver
  enableClickToPay
}
    ${TradePartnerDetails_PaymentTermFragmentDoc}`;
export const TradePartnerDetailsTabDocument = gql`
    query TradePartnerDetailsTab($id: ID!, $isNew: Boolean!) {
  tradePartner(id: $id) @skip(if: $isNew) {
    ...TradePartnerDetails
  }
  markets {
    id
    name
  }
  internalUsers {
    id
    name
    avatar
  }
  tradeCategories {
    id
    name
  }
  costCodes(filter: {version: 2}) {
    id
    displayName
  }
  paymentTerms(filter: {active: true}) {
    ...TradePartnerDetails_PaymentTerm
  }
}
    ${TradePartnerDetailsFragmentDoc}
${TradePartnerDetails_PaymentTermFragmentDoc}`;

/**
 * __useTradePartnerDetailsTabQuery__
 *
 * To run a query within a React component, call `useTradePartnerDetailsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerDetailsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerDetailsTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isNew: // value for 'isNew'
 *   },
 * });
 */
export function useTradePartnerDetailsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables> & ({ variables: TradePartnerDetailsTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables>(TradePartnerDetailsTabDocument, options);
      }
export function useTradePartnerDetailsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables>(TradePartnerDetailsTabDocument, options);
        }
export function useTradePartnerDetailsTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables>(TradePartnerDetailsTabDocument, options);
        }
export type TradePartnerDetailsTabQueryHookResult = ReturnType<typeof useTradePartnerDetailsTabQuery>;
export type TradePartnerDetailsTabLazyQueryHookResult = ReturnType<typeof useTradePartnerDetailsTabLazyQuery>;
export type TradePartnerDetailsTabSuspenseQueryHookResult = ReturnType<typeof useTradePartnerDetailsTabSuspenseQuery>;
export type TradePartnerDetailsTabQueryResult = Apollo.QueryResult<TradePartnerDetailsTabQuery, TradePartnerDetailsTabQueryVariables>;